document.addEventListener("DOMContentLoaded", function () {

    const segmentsList = [
        { id: 1, name: 'Utilities', iconName: 'Utilities.svg', color: '#00C4B3', isActive: true },
        { id: 2, name: 'Energy', iconName: 'Energy.svg', color: '#ACACAC', isActive: true },
        { id: 3, name: 'Materials', iconName: 'Materials.svg', color: '#697AB6', isActive: true },
        { id: 4, name: 'Financials', iconName: 'Financials.svg', color: '#C8C8C8', isActive: true },
        { id: 5, name: 'Health Care', iconName: 'Health-Care.svg', color: '#E54360', isActive: true },
        { id: 6, name: 'Real Estate', iconName: 'Materials.svg', color: '#CAD1EA', isActive: true },
        { id: 7, name: 'Information-Technology', iconName: 'Information-Technology.svg', color: '#00945E', isActive: true },
        { id: 8, name: 'Industrials', iconName: 'Industrials.svg', color: '#3636E3', isActive: true },
        { id: 9, name: 'Communication Services', iconName: 'Communication-Services.svg', color: '#697AB6', isActive: true },
        { id: 10, name: 'Consumer Staples', iconName: 'Consumer-Staples.svg', color: '#6993DE', isActive: true },
        { id: 11, name: 'Consumer Discretionary', iconName: 'Customer-Discretionary.svg', color: '#FFC629', isActive: true },
    ]
    let topN = 6;
    let sectorIds = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    const getCache = (typeof window !== 'undefined' && typeof window.getCacheItem === 'function') ? window.getCacheItem : function(){ return null; };
    const setCache = (typeof window !== 'undefined' && typeof window.setCacheItem === 'function') ? window.setCacheItem : function(){};
    let primeAction = getCache('lastChartType') || 'topdollar';
    if (primeAction === 'myportfolio-price') primeAction = 'watchlist-reports';
    let secondaryAction = 'sec';

    const getSegmentsCacheKey = (action) => `segments_state_${action}`;

    function saveSegmentsState() {
        if (primeAction === 'watchlist-reports') return;
        const state = {
            secondaryAction,
            sectorIds,
            topN
        };
        const EXPIRATION_TIME = typeof CACHE_EXPIRATION !== 'undefined' ? CACHE_EXPIRATION.PERSISTENT : 5256000;
        setCache(getSegmentsCacheKey(primeAction), state, EXPIRATION_TIME);
    }

    function syncSegmentsUI() {
        const segmentsItems = document.querySelectorAll('#sectors-assets-pop-up .item');
        segmentsItems.forEach(item => {
            const id = parseInt(item.dataset.id);
            if (sectorIds.includes(id)) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });

        const depthInput = document.querySelector('#sectors-assets-pop-up .sector-depth input');
        if (depthInput) {
            depthInput.value = topN;
        }
        const sectorsBreaksContainer = document.querySelector('#sectors-assets-pop-up .sectors-breaks-container');
        const depthContainer = document.querySelector('#sectors-assets-pop-up .sector-depth');
        const contentContainer = document.querySelector('#sectors-assets-pop-up .content');
        const popupContainer = document.querySelector('#sectors-assets-pop-up');

        if (sectorsBreaksContainer) {
            if (secondaryAction === 'sec') {
                sectorsBreaksContainer.classList.add('active');
                if (depthContainer) depthContainer.classList.remove('disabled');
                if (contentContainer) contentContainer.classList.remove('disabled');
                if (popupContainer) popupContainer.classList.remove('short');
            } else {
                sectorsBreaksContainer.classList.remove('active');
                if (depthContainer) depthContainer.classList.add('disabled');
                if (contentContainer) contentContainer.classList.add('disabled');
                if (popupContainer) popupContainer.classList.add('short');
            }
        }
    }

    function loadSegmentsState(action) {
        if (action === 'watchlist-reports') return;
        
        const state = getCache(getSegmentsCacheKey(action));
        if (state) {
            secondaryAction = state.secondaryAction || 'sec';
            sectorIds = state.sectorIds || [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
            topN = state.topN || 6;
        } else {
            secondaryAction = 'sec';
            sectorIds = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
            topN = 6;
        }
        syncSegmentsUI();
    }

    loadSegmentsState(primeAction);

    const initialButton = document.querySelector(`#main-block .filters-container .item[data-action="${primeAction}"]`);
    if (initialButton) {
        const categoryButtons = document.querySelectorAll('#main-block .filters-container .item');
        categoryButtons.forEach(btn => btn.classList.remove('active'));
        initialButton.classList.add('active');
    }

    const scene = document.querySelector('a-scene');
    if (scene) {
        scene.addEventListener('center-panel-initialized', () => {
            applySectorsAndDepthToCube();
        });
        applySectorsAndDepthToCube();
    }

    const minPriceInput = document.getElementById('sip-minprice');
    const minCapInput = document.getElementById('sip-mincap');
    const minPriceLabel = document.getElementById('sip-minprice-label');
    const minCapLabel = document.getElementById('sip-mincap-label');
    const sceneEl = document.querySelector('a-scene');

    const segmentsContainer = document.querySelector('#sectors-assets-pop-up .content');
    segmentsContainer.innerHTML = '';

    segmentsList.forEach((segment, index) => {
        const leftSide = `
                <div class="left-side">
                    <div class="dot" style="background: ${segment.color}"></div>
                    <div class="icon-wrapper"><img src="./desktop_assets/pop-up/sectors/${segment.iconName}" alt=""></div>
                    <p>${segment.name}</p>
                </div>
        `
        const rightSide = `
                <div class="checkbox-container">
                    <img src="./desktop_assets/pop-up/checkbox-active-2.svg" alt="" class="active-stage">
                </div>       
        `
        const isActive = sectorIds.includes(segment.id);
        segmentsContainer.innerHTML += `<div class="item ${isActive ? 'active' : ''}" data-id="${segment.id}">${leftSide}${rightSide}</div>`
    })

    const segmentsItems = document.querySelectorAll('#sectors-assets-pop-up .item');
    segmentsItems.forEach(item => {
        item.addEventListener('click', () => {
            item.classList.toggle('active');

            sectorIds = [];
            segmentsItems.forEach(elem => {
                if (elem.classList.contains('active')) {
                    const id = parseInt(elem.dataset.id);
                    if (!sectorIds.includes(id)) {
                        sectorIds.push(id);
                    }
                }
            })

            saveSegmentsState();
            applySectorsAndDepthToCube();
        })
    })

    const categoryButtons = document.querySelectorAll('#main-block .filters-container .item');
    categoryButtons.forEach(button => {
        button.addEventListener('click', () => {
            const newPrimeAction = button.dataset.action;

            
            if (window.gtag) {
                const prettyName = {
                    topdollar: "TopDollar",
                    gainers: "Gainers",
                    losers: "Losers",
                    topvol: "Volume",
                    dividend: "Dividend",
                    sip: "ShortInterest",
                    marketmap: "Marketmap",
                    "watchlist-reports": "Watchlist",
                }
                
                gtag('event', `Desktop_TopNav_${prettyName[newPrimeAction] || null}`);
                // window.dataLayer.push({
                //     event: `Desktop_TopNav_${prettyName[primeAction] || null}`
                // });
            }

            if (newPrimeAction === 'watchlist-reports') {
                if (window.consentGiven === false) {
                    if (window.AuthUI && window.AuthUI.showMessage) {
                        window.AuthUI.showMessage('Login restricted. You cannot login until you accept the cookies');
                    }
                    return;
                }
                if (window.WatchlistApp && window.WatchlistApp.Manager && window.WatchlistApp.Manager.checkWatchlistAccess) {
                     const access = window.WatchlistApp.Manager.checkWatchlistAccess();
                     if (!access.allowed) {
                         window.WatchlistApp.Manager.enterWatchlistMode();
                         return;
                     }
                }
            }

            categoryButtons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active')

            if (newPrimeAction !== primeAction) {
                const wasSipOrDividend = primeAction === 'sip' || primeAction === 'dividend';
                const isNowSipOrDividend = newPrimeAction === 'sip' || newPrimeAction === 'dividend';

                if (wasSipOrDividend && !isNowSipOrDividend) {
                    const dataIntervalItems = document.querySelectorAll('#main-block .time-range-wrapper .item');
                    dataIntervalItems.forEach(el => el.classList.remove('active'));
                    const defaultIntervalEl = Array.from(dataIntervalItems).find(el => el.dataset.range === '1D');
                    if (defaultIntervalEl) defaultIntervalEl.classList.add('active');
                }

                loadSegmentsState(newPrimeAction);
            }

            if (newPrimeAction === 'watchlist-reports') {
                if (window.WatchlistApp && window.WatchlistApp.Manager) {
                     window.WatchlistApp.Manager.enterWatchlistMode();
                     primeAction = newPrimeAction;
                     updateChart();
                }
                return;
            }

            if (document.body.classList.contains('watchlist-mode') && window.WatchlistApp && window.WatchlistApp.Manager) {
                window.WatchlistApp.Manager.exitWatchlistMode(false);
            }

            primeAction = newPrimeAction;

            if (newPrimeAction === 'marketmap') {
                document.body.classList.add('mmap-graph');
            }

            updateChart()

        })
    })

    const depthUp = document.querySelector('#sectors-assets-pop-up .depth-up');
    const depthDown = document.querySelector('#sectors-assets-pop-up .depth-down');
    const depthInput = document.querySelector('#sectors-assets-pop-up .sector-depth input');
    const maxDepth = 10;
    const minDepth = 1;
    depthDown.addEventListener('click', () => {
        let currentDepth = parseInt(depthInput.value);
        if (currentDepth > minDepth) {
            depthInput.value = currentDepth - 1;
            topN = parseInt(depthInput.value);
            saveSegmentsState();
            applySectorsAndDepthToCube();
        }
    })
    depthUp.addEventListener('click', () => {
        let currentDepth = parseInt(depthInput.value);
        if (currentDepth < maxDepth) {
            depthInput.value = currentDepth + 1;
            topN = parseInt(depthInput.value);
            saveSegmentsState();
            applySectorsAndDepthToCube();
        }
    })

    const popupContainer = document.querySelector('#sectors-assets-pop-up');
    const sectorsBreaksContainer = document.querySelector('#sectors-assets-pop-up .sectors-breaks-container')
    const depthContainer = document.querySelector('#sectors-assets-pop-up .sector-depth');
    const contentContainer = document.querySelector('#sectors-assets-pop-up .content');
    sectorsBreaksContainer.addEventListener('click', () => {
        sectorsBreaksContainer.classList.toggle('active');

        const isActive = sectorsBreaksContainer.classList.contains('active');
        secondaryAction = isActive ? 'sec' : 'gen';
        if (isActive) {
            depthContainer.classList.remove('disabled');
            contentContainer.classList.remove('disabled');
            popupContainer.classList.remove('short');
        } else {
            depthContainer.classList.add('disabled');
            contentContainer.classList.add('disabled');
            popupContainer.classList.add('short');
        }
        saveSegmentsState();
        updateChart();

        if (window.gtag) gtag('event', `Desktop_CenterPanel_Sectors`, { mode: isActive ? 'sector' : 'non-sector' });
    })


    function applySectorsAndDepthToCube() {
        const stock3dCube = document.querySelector('a-scene#main-scene #stock-3d-cube');
        if (stock3dCube) {
            stock3dCube.setAttribute('stock-cube-visualizer', {
                sectorIds,
                topN
            });
        }
    }

    function resetSectorsPopupSettings() {
        if (__LOG_INFO__) AppLog.info('Resetting sectors popup settings');

        secondaryAction = 'sec';
        sectorIds = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
        topN = 6;

        syncSegmentsUI();
        resetSipFilters();

        applySectorsAndDepthToCube();
    }

    function resetSipFilters() {
        if (__LOG_INFO__) AppLog.info('Resetting SIP filters');

        if (minPriceInput) minPriceInput.value = 1;
        if (minCapInput) minCapInput.value = 10000000000;

        updateLabels();
        emitSipFilters();
    }

    function updateMmapModeUI(mode) {
        const isMmap3D = mode === '3d';
        const sectorsBtn = document.querySelector('.open-pop-up-segments-assets');
        const itemsRow = document.querySelector('.rotation-container .items-row');
        const rotationReset = document.querySelector('#main-block .rotation-container .reset');
        const mmapAdditional = document.querySelector('.mmap-additional-controls');
        const btn3D = document.querySelector('.btn-mmap-3d-view');
        const btn2D = document.querySelector('.btn-mmap-2d-view');
        const btnBuildings = document.querySelector('.btn-mmap-buildings');
        const rotateMoveActionSwitcher = document.querySelector('#main-block .chart-wrapper .rotate-move-switcher-container:not(.marketmap-move-zoom-switcher-container)') 


        if (mmapAdditional) mmapAdditional.style.display = '';

        if (isMmap3D) {
            document.body.classList.add('mmap-3d');
            if (sectorsBtn) sectorsBtn.style.display = 'none';
            if (itemsRow) itemsRow.style.display = '';
            if (rotationReset) rotationReset.style.display = '';
            if (btn3D) btn3D.style.display = 'none';
            if (btn2D) btn2D.style.display = '';
            if (btnBuildings) btnBuildings.style.display = 'none';
            if (rotateMoveActionSwitcher) rotateMoveActionSwitcher.classList.remove('force-hide');
        } else {
            // 2D Mode
            document.body.classList.remove('mmap-3d');
            if (sectorsBtn) sectorsBtn.style.display = 'none';
            if (itemsRow) itemsRow.style.display = 'none';
            if (rotationReset) rotationReset.style.display = '';
            if (btn3D) btn3D.style.display = '';
            if (btn2D) btn2D.style.display = 'none';
            if (btnBuildings) btnBuildings.style.display = '';
            if (rotateMoveActionSwitcher) rotateMoveActionSwitcher.classList.add('force-hide');
        }

        // Exit buildings mode if switching modes while active
        if (window.MarketMapBuildingsMode && window.MarketMapBuildingsMode.isActive()) {
            window.MarketMapBuildingsMode.exit();
        }

        const breaksToggle = document.querySelector('#sectors-assets-pop-up .sectors-breaks-container');
        const depthContainer = document.querySelector('#sectors-assets-pop-up .sector-depth');
        const contentCont = document.querySelector('#sectors-assets-pop-up .content');
        const popupCont = document.querySelector('#sectors-assets-pop-up');

    }

    function syncChartTypeControlsLayout() {
        const isMarketMap = primeAction === 'marketmap';
        const mainControls = document.querySelector('.main-controls');
        const bottomPlayer = document.querySelector('.bottom-player-area');
        const timelineContainer = document.querySelector('.timeline-container');
        const itemsRow = mainControls?.querySelector('.rotation-container .items-row');
        const sectorsBtn = document.querySelector('.open-pop-up-segments-assets');
        const isSearchMode = document.body.dataset.isSearchMode === 'true';

        if (isMarketMap) {
            if (bottomPlayer) bottomPlayer.style.display = 'none';
            if (timelineContainer) timelineContainer.style.display = '';
            document.body.classList.add('mmap-graph');
            const popup = document.querySelector('#sectors-assets-pop-up');
            if (popup) popup.classList.remove('show');
            updateMmapModeUI(getCache('mmap_view_mode') || '2d');
            window.hasPerformedInitialZoomFit = false;
            return;
        }

        if (!isSearchMode) {
            if (mainControls) mainControls.style.display = '';
            if (bottomPlayer) bottomPlayer.style.display = '';
            if (timelineContainer) timelineContainer.style.display = '';
        }
        
        if (itemsRow) itemsRow.style.display = '';
        if (sectorsBtn) sectorsBtn.style.display = '';
        const mmapAdditional = document.querySelector('.mmap-additional-controls');
        if (mmapAdditional) mmapAdditional.style.display = 'none';

        const rotationReset = document.querySelector('#main-block .rotation-container .reset');
        if (rotationReset) rotationReset.style.display = '';

        document.body.classList.remove('mmap-graph');
        document.body.classList.remove('mmap-3d');
        window.hasPerformedInitialZoomFit = false;
    }

    function updateChart() {
        if (__LOG_INFO__) AppLog.info('update chart', primeAction, secondaryAction)

        if (window.exitNewsGraphMode) {
            window.exitNewsGraphMode();
        }
        window.StockStormHideMainBlockHoverPopup?.();

        syncChartTypeControlsLayout();

        if (document.body.classList.contains('watchlist-mode')) {
            if (__LOG_INFO__) AppLog.info('[Segments Control] Watchlist mode detected, preventing default chart update');

            const playerContainer = document.querySelector('.bottom-player-area .player-container');
            const sipControlsWrapper = document.querySelector('.bottom-player-area .sip-controls-wrapper');
            if (playerContainer) playerContainer.style.display = '';
            if (sipControlsWrapper) sipControlsWrapper.style.display = 'none';

            const timelineContainer = document.querySelector('#main-block .timeline-container');
            if (timelineContainer) timelineContainer.style.display = '';

            const centerPanelContainer = document.getElementById('center-panel-container');
            if (centerPanelContainer) {
                centerPanelContainer.setAttribute('position', '0 2.7 -1.2');
            }

            let centerContent = document.getElementById('large-center-panel-content');
            if (centerContent) {
                centerContent.replaceChildren();
                centerContent.setAttribute('position', '0 0 0');
            }

            if (typeof addWatchlistReportsCubeToCenterPanel === 'function') {
                addWatchlistReportsCubeToCenterPanel();

                const App = window.WatchlistApp;
                if (App && App.State) {
                    const State = App.State;
                    const stockCube = document.getElementById('stock-3d-cube');
                    if (stockCube && State.currentWatchlistId) {
                        let currentInterval = '1d';
                        const activeIntervalBtn = document.querySelector('#main-block .time-range-wrapper .item.active');
                        if (activeIntervalBtn) currentInterval = activeIntervalBtn.getAttribute('data-range');
                        currentInterval = currentInterval.toLowerCase();

                        if (__LOG_INFO__) AppLog.info('[Segments Control] Re-applying watchlist attributes', {
                            watchlistId: State.currentWatchlistId
                        });

                        stockCube.setAttribute('stock-cube-visualizer', {
                            dataSource: 'watchlist-reports',
                            interval: currentInterval,
                            watchlistId: State.currentWatchlistId,
                            injectedData: State.lastReportData ? JSON.stringify(State.lastReportData) : ''
                        });
                    }
                }
            } else {
                if (__LOG_WARN__) AppLog.warn('[Segments Control] addWatchlistReportsCubeToCenterPanel function not found');
            }
            return;
        }

        const playerContainer = document.querySelector('.bottom-player-area .player-container');
        const sipControlsWrapper = document.querySelector('.bottom-player-area .sip-controls-wrapper');
        const showSip = primeAction === 'sip' || primeAction === 'dividend';

        if (playerContainer) playerContainer.style.display = showSip ? 'none' : '';
        if (sipControlsWrapper) {
            sipControlsWrapper.style.display = showSip ? '' : 'none';
            sipControlsWrapper.classList.toggle('invisible', !showSip)
        }

        const timelineContainer = document.querySelector('#main-block .timeline-container');
        if (timelineContainer) {
            timelineContainer.style.display = showSip ? 'none' : '';
        }
        const centerPanelContainer = document.getElementById('center-panel-container');
        if (centerPanelContainer) {
            const attrNames = centerPanelContainer.getAttributeNames ? centerPanelContainer.getAttributeNames() : [];
            attrNames.forEach(name => {
                if (name.startsWith('animation__')) centerPanelContainer.removeAttribute(name);
            });
            if (showSip) {
                centerPanelContainer.setAttribute('position', '0 2.45 -1.2');
            } else {
                centerPanelContainer.setAttribute('position', '0 2.7 -1.2');
            }
        }

        let centerContent = document.getElementById('large-center-panel-content');
        if (centerContent) {
            centerContent.replaceChildren();
            centerContent.setAttribute('position', '0 0 0');
        }

        const camera = document.querySelector('#camera');
        if (camera) {
            const currentPosition = camera.getAttribute('position') || { x: 0, y: 2.75, z: 2 };
            camera.setAttribute('position', {
                x: 0,
                y: 2.75,
                z: currentPosition.z
            });
        }

        const EXPIRATION_TIME = typeof CACHE_EXPIRATION !== 'undefined' ? CACHE_EXPIRATION.PERSISTENT : 5256000;
        setCache('lastChartType', primeAction, EXPIRATION_TIME);

        const isDividendOrSip = primeAction === 'dividend' || primeAction === 'sip';
        let activeInterval;
        if (isDividendOrSip) {
            activeInterval = '1Y';
        } else {
            const activeIntervalEl = document.querySelector('#main-block .time-range-wrapper .item.active');
            activeInterval = (activeIntervalEl && activeIntervalEl.dataset.range) || getCache('data-interval') || '1D';
        }
        setCache('data-interval', activeInterval, EXPIRATION_TIME);

        if (primeAction === 'gainers' && secondaryAction === 'gen') addStockGainersToCenterPanel();
        if (primeAction === 'gainers' && secondaryAction === 'sec') addStockGainersSectorToCenterPanel();
        if (primeAction === 'losers' && secondaryAction === 'gen') addStockLosersToCenterPanel();
        if (primeAction === 'losers' && secondaryAction === 'sec') addStockLosersSectorToCenterPanel();
        if (primeAction === 'topvol' && secondaryAction === 'gen') addStockByVolRankCubeToCenterPanel();
        if (primeAction === 'topvol' && secondaryAction === 'sec') addStockByVolCubeToCenterPanel();
        if (primeAction === 'topdollar' && secondaryAction === 'gen') addStockTopDollarCubeToCenterPanel();
        if (primeAction === 'topdollar' && secondaryAction === 'sec') addStockTopDollarSectorCubeToCenterPanel();
        if (primeAction === 'sip' && secondaryAction === 'gen') addShortInterestCubeToCenterPanel();
        if (primeAction === 'sip' && secondaryAction === 'sec') addShortInterestSectorCubeToCenterPanel();
        if (primeAction === 'dividend' && secondaryAction === 'gen') addDividendCubeToCenterPanel();
        if (primeAction === 'dividend' && secondaryAction === 'sec') addDividendSectorCubeToCenterPanel();

        if (primeAction === 'marketmap') {
            addMarketMapCubeToCenterPanel();
            const cachedMmapMode = getCache('mmap_view_mode') || '2d';
            updateMmapModeUI(cachedMmapMode);
        }

        const playerContainerEl = document.querySelector('#main-block .player-container')
        if (playerContainerEl) playerContainerEl.classList.remove('disabled')
        
        // update UI according to saved values
        const dataIntervalItems = document.querySelectorAll('#main-block .time-range-wrapper .item');
        dataIntervalItems.forEach(el => el.classList.remove('active'));
        const targetEl = Array.from(dataIntervalItems).find(el => el.dataset.range === activeInterval);
        if (targetEl) {
            targetEl.classList.add('active');
        } else if (dataIntervalItems[0]) {
            dataIntervalItems[0].classList.add('active');
        }

        const sceneEl = document.querySelector('a-scene');
        const noSelectedStockMessage = document.querySelector('#no-selected-stock-message');
        const stockChart = document.getElementById('stock-chart');
        const stockWrapper = document.querySelector('#right-live-chart');
        const existingUniversal = stockChart.getAttribute('tradingview-universal-chart');
        if (!stockChart || !stockWrapper || !noSelectedStockMessage || !existingUniversal) return
        if (__LOG_INFO__) AppLog.info('ks data-interval-dividend', primeAction)
        sceneEl.emit('data-interval-dividend', { interval: (primeAction === 'dividend' || primeAction === 'sip') ? '1Y' : '1D' });
        if (primeAction === 'dividend') {
            const rightAverageVolumeEl = document.querySelector('#right-average-volume');
            if (rightAverageVolumeEl) rightAverageVolumeEl.classList.remove('show')
        }


        const stockData = existingUniversal.stockData
        const ticker = JSON.parse(stockData)?.ticker || null
        if (__LOG_INFO__) AppLog.info('ks ticker', ticker, noSelectedStockMessage)
        if (ticker === 'SPY') {
            const showPlaceholder = primeAction === 'dividend' || primeAction === 'sip';
            noSelectedStockMessage.classList.toggle('show', showPlaceholder);
            stockWrapper.classList.toggle('show', !showPlaceholder);

            if (showPlaceholder) {
                const p = noSelectedStockMessage.querySelector('p');
                if (p) {
                    p.innerHTML = primeAction === 'dividend' 
                        ? 'Select a stock to <br>view dividend chart' 
                        : 'Select a stock to <br>view short interest chart';
                }
            }
        } else {
            noSelectedStockMessage.classList.remove('show');
            stockWrapper.classList.add('show');
        }
        applySectorsAndDepthToCube();
    }

    function formatCap(n) {
        const num = Number(n);
        if (num >= 1e12) return `$${(num / 1e12).toFixed(0)}T`;
        if (num >= 1e9) return `$${(num / 1e9).toFixed(0)}B`;
        if (num >= 1e6) return `$${(num / 1e6).toFixed(0)}M`;
        return `$${num.toFixed(0)}`;
    }

    function emitSipFilters() {
        if (!sceneEl) return;
        const minPrice = Number(minPriceInput?.value || 1);
        const minCap = Number(minCapInput?.value || 10_000_000_000);
        sceneEl.emit('sip-filters-changed', { minPrice, minCap });
    }

    function updateLabels() {
        if (minPriceLabel && minPriceInput) minPriceLabel.textContent = `$${Number(minPriceInput.value).toFixed(0)}`;
        if (minCapLabel && minCapInput) minCapLabel.textContent = formatCap(minCapInput.value);
    }

    if (minPriceInput && minCapInput) {
        minPriceInput.addEventListener('input', () => { updateLabels(); emitSipFilters(); });
        minCapInput.addEventListener('input', () => { updateLabels(); emitSipFilters(); });
        updateLabels();
    }

    const btn3DView      = document.querySelector('.btn-mmap-3d-view');
    const btn2DView      = document.querySelector('.btn-mmap-2d-view');
    const btnMmapReset   = document.querySelector('.btn-mmap-reset');
    const btnBuildings   = document.querySelector('.btn-mmap-buildings');

    if (btnBuildings) {
        btnBuildings.addEventListener('click', () => {
            if (window.MarketMapBuildingsMode) {
                if (window.MarketMapBuildingsMode.isActive()) {
                    window.MarketMapBuildingsMode.exit();
                } else {
                    window.MarketMapBuildingsMode.enter();
                }
            }
        });
    }

    // Exit buildings mode if user manually exits fullscreen
    document.addEventListener('fullscreenchange', () => {
        if (!document.fullscreenElement && window.MarketMapBuildingsMode && window.MarketMapBuildingsMode.isActive()) {
            window.MarketMapBuildingsMode.exit();
        }
    });

    if (btn3DView) {
        btn3DView.addEventListener('click', () => {
            if (window.MarketMapModeSwitching) {
                window.MarketMapModeSwitching.switchTo3D();
                updateMmapModeUI('3d');

                if(window.gtag) gtag('event', `Desktop_TopNav_Marketmap3D`);
            }
        });
    }
    if (btn2DView) {
        btn2DView.addEventListener('click', () => {
            if (window.MarketMapModeSwitching) {
                window.MarketMapModeSwitching.switchTo2D();
                updateMmapModeUI('2d');

                if(window.gtag) gtag('event', `Desktop_TopNav_Marketmap2D`);
            }
        });
    }
    if (btnMmapReset) {
        btnMmapReset.addEventListener('click', () => {
            const existingReset = document.querySelector('#main-block .rotation-container .reset');
            if (existingReset) existingReset.click();

            const mmapMode = getCache('mmap_view_mode') || '2d';
            if (mmapMode === '2d') {
                const el = document.getElementById('stock-3d-cube');
                if (el && el.components && el.components['stock-cube-visualizer']) {
                    const viz = el.components['stock-cube-visualizer'];
                    viz.mmap2DPosition = null;
                    viz.mmapWrapperOriginalPosition = null;
                    viz.mmapContainerOriginalPosition = null;
                    window.MarketMapSharedRendering.renderMarketMap(viz, viz.currentData || null);
                }
            }
        });
    }

    if (sceneEl) {
        sceneEl.addEventListener('mmap-mode-changed', (e) => {
            if (primeAction === 'marketmap') {
                updateMmapModeUI((e.detail && e.detail.mode) || '2d');
            }
        });
    }

    document.addEventListener('configure-changed', (event) => {
        if (event.detail && event.detail.rebuild) {
            updateChart();
        }
    });
    updateChart();
})
